import AppoinmentHistory from "../components/AppoinmentHistory/AppoinmentHistory";
import DoctorAppoinmentHistory from "../components/AppoinmentHistory/DoctorAppointmentHistory";
import Faq from "../components/FAQ/Faq";
import TermsandConditions from "../components/TermsandConditions";
import SeparatePrivacy from "../components/TermsandConditions/SeparatePrivacy";
import SeparateTerms from "../components/TermsandConditions/SeparateTerms";


export const DASHBOARD_LEFT_OPTIONS = [
    {
        tittle: "MY APPOINTMENT",
        options: [
            {
                name: "Book a consultation",
                ico: <i class="fal fa-book-medical"></i>,
                component: null,
                date: "",

            },
            {
                name: "Appointment History",
                component: <AppoinmentHistory />,
                ico: <i class="fal fa-calendar-check"></i>,
                target: "/dashboard/history"
            },
        ]
    },
    {
        tittle: "SETTINGS",
        options: [
            {
                name: "Terms and Conditions",
                ico: <i class="fal fa-clipboard-list"></i>,
                component: <SeparateTerms typeId='terms' />,
                target: "/dashboard/terms"
            },
            {
                name: "Privacy Policy",
                ico: <i class="fal fa-user-secret"></i>,
                component: <SeparatePrivacy typeId="privacy" />,
                target: "/dashboard/privacy"
            },
            {
                name: "FAQ",
                ico: <i class="fal fa-question"></i>,
                component: <Faq typeId="privacy" />,
                target: "/dashboard/faq"
            },
        ]
    },


]


export const DOCTOR_DASHBOARD_LEFT_OPTIONS = [
    {
        tittle: "MY APPOINTMENTS",
        options: [
            {
                name: "Appointment History",
                component: <DoctorAppoinmentHistory />,
                ico: <i class="fal fa-calendar-check"></i>
            },
        ]
    },
    {
        tittle: "SETTINGS",
        options: [
            // {
            //     name:"My Profile",
            //     ico:<i class="fal fa-user"></i>,
            //     component:<SeparateTerms typeId='terms'/>
            // },

            {
                name: "Terms and Conditions",
                ico: <i class="fal fa-clipboard-list"></i>,
                component: <SeparateTerms typeId='terms' />
            },
            {
                name: "Privacy Policy",
                ico: <i class="fal fa-user-secret"></i>,
                component: <SeparatePrivacy typeId="privacy" />
            },
            {
                name: "FAQ",
                ico: <i class="fal fa-question"></i>,
                component: <Faq typeId="privacy" />
            },
        ]
    },


]

export const validateIsEmpty = (param, ret) => {

    if (param && param != undefined && param != "undefined" && param != "") {
        return param
    }
    else {
        return ret ? ret : ""
    }

}

export const ARABIC_THEME = "Arabic"

export const PASSWORD_REX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/


export const DUMMY_PRESCRIPTION = {
    "patientDetails": {
        "patient_id": "123",
        "patient_name": "asdadasd",
        "dob": "2023-01-16T03:30:37.462Z",
        "gender": "Female",
        "height_value": 0,
        "height_messurment": "cm",
        "weight_value": 0,
        "weight_messurment": "kg",
        "lmp": "2023-01-11T03:30:47.272Z"
    },
    "consultationNotes": {
        "symptoms": [
            {
                "name": "Fever",
                "since": "1D",
                "severity": "Mild",
                "more": "Convulsions",
                "grade": "High",
                "note": "asd"
            }
        ],
        "medicalHistory": [
            {
                "name": "T2DM"
            }
        ],
        "medical_history_note": "asd",
        "examinations": [
            {
                "name": "Tachypnea"
            }
        ],
        "diagnosis": [
            {
                "name": "Viral Fever"
            }
        ],
        "vaccinationStatus": "Yes",
        "vaccinationDoseCount": "2",
        "vaccinationNames": [
            "Vaccine-1"
        ]
    },
    "treatmentAdvice": {
        "investigations": [
            {
                "name": "Urine Routine Microscopic (R/M)"
            }
        ],
        "instructions": [
            {
                "name": "Inform if fever more than 72 hours"
            },
            {
                "name": "Plently of fluids"
            }
        ],
        "medications": [
            {
                "name": "Sus Calpol (250 mg)",
                "quantity": "1.5",
                "default_timing": "6h",
                "default_timing_custom": "After Food",
                "custom_duration": "2d",
                "note": "asd"
            }
        ]
    },
    "followup": {
        "followup_date": {
            "isDate": true,
            "value": "2023-01-25T04:32:47.815Z"
        }
    },
    "referral": {
        "speciality": "Option-1",
        "referral": "Option-2",
        "referral_note": "asas"
    }
}

export const DepartmentFaqList = [{
    question: "What is telemedicine?",
    answer: "Telemedicine is the practice of providing medical care remotely using telecommunications technology. It allows patients to consult with healthcare providers through video or audio calls, online messaging, or other virtual platforms."
},
{
    "question": "How does telemedicine work?",
    "answer": "Telemedicine typically involves a patient scheduling a virtual appointment with a healthcare provider through a secure online platform or app. During the appointment, the patient and provider communicate via video or audio call, allowing for evaluation, diagnosis, treatment, and medical advice."
},
{
    "question": "What are the benefits of telemedicine?",
    "answer": "Telemedicine offers several advantages, including increased access to healthcare, convenience and time-saving, reduced exposure to contagious diseases, efficient follow-up care, monitoring of chronic conditions, and cost savings for both patients and healthcare providers."
},
{
    "question": "What types of healthcare services are suitable for telemedicine?",
    "answer": "Telemedicine can be used for various healthcare needs, including routine check-ups, primary care consultations, counseling and therapy sessions, prescription refills and medication management, follow-up appointments and test result discussions, remote monitoring of chronic conditions, and pre and post-operative care."
},
{
    "question": "Is telemedicine secure and private?",
    "answer": "Telemedicine platforms prioritize patient privacy and employ secure technology to protect confidential health information. Ensure you choose a reputable telemedicine provider that complies with privacy regulations and encrypts data transmission."
},
{
    "question": "Can telemedicine replace in-person doctor visits?",
    "answer": "While telemedicine is an effective means of remote healthcare delivery, it may not completely replace in-person visits. Some medical conditions require physical examinations or diagnostic tests that cannot be conducted virtually. Telemedicine is best suited for non-emergency, low-risk, and routine medical needs."
},
{
    "question": "Can prescriptions be provided through telemedicine?",
    "answer": "Yes, healthcare providers can prescribe medications during telemedicine appointments, if deemed appropriate. They can electronically send prescriptions."
},
{
    "question": "Is telemedicine covered by insurance?",
    "answer": "Many insurance plans now offer coverage for telemedicine services. However, coverage may vary, so it's advisable to check with your insurance provider to understand the specific details of your plan. If approved, once you make the payment we will provide you with an invoice which you can submit to your insurance provider to avail your claims."
},
{
    "question": "What technology do I need for a telemedicine appointment?",
    "answer": "Generally, you'll need a smartphone, tablet, or computer with a camera, microphone, and internet access to join a telemedicine consult. Digital payment mechanisms like Credit Card, Debit Card, UPI, etc. to make payments."
},
{
    "question": "How do I schedule a telemedicine appointment?",
    "answer": "Make a payment and submit your request. The telehealth coordinator from the healthcare provider's office will inquire about telemedicine services and schedule an appointment. They will guide you on the necessary steps to set up and access the telemedicine platform."
}
]